import { LoginViewOnLoginEpic } from './LoginViewOnLoginEpic';
import { LoginViewOnLoginSuccessfulEpic } from './LoginViewOnLoginSuccessfulEpic';

export const rootAppViewEpics = [
  LoginViewOnLoginEpic,
  LoginViewOnLoginSuccessfulEpic,
];
